import ActiveItemDivider from 'components/active-item/ActiveItemDivider';
import { useRefreshItems } from 'hooks/useRefreshItems';
import { useSoundPath } from 'hooks/useSoundPath';
import { CardPacksContext } from 'pages/CardPacks';
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { createAPI } from 'services/api/api';
import { setError } from 'store/user';

const CombinePacks = () => {
  const api = createAPI();
  const refresh = useRefreshItems();
  const playSound = useSoundPath();
  const dispatch = useDispatch();
  const { selectMode, setSelectMode, selectedItems, setSelectedItems, setIsSuccessVisible } = useContext(CardPacksContext);
  const [isLoading, setIsLoading] = useState(false);
  const [combineText, setCombineText] = useState('Cards');
  const [combineHint, setCombineHint] = useState('Combine two or more prize cards into a single card. The new card prize amount will be the sum of the combined cards.');


  const combineCards = async () => {
    playSound('main');
    setIsLoading(true)
    const selectedIds = selectedItems.map((prize) => prize.id);
    const payload = {card_pack_ids: selectedIds};

    await api.post(`/card_pack/open`, payload)
      .then(() => {
        setIsSuccessVisible(true)
        setSelectedItems([]);
        setSelectMode(false);
        refresh();
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.log(error)
        dispatch(setError(error.response.data.message))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }



  useEffect(() => {
    if (selectedItems.length < 2) {
      setCombineText('Packs');
      setCombineHint('Select multiple card packs and open them instantly. All of the cards from opened packs will be added to your inventory.')
    } else {
      setCombineText(`${selectedItems.length} Packs`)
    }
  }, [selectedItems])

  return (
    <>
      <section className="card-details__combine">
        <h3 className="card-details__combine-title">Open Multiple Packs</h3>
        <div className="card-details__combine-actions">
          <button
            className={`card-details__combine-action card-details__combine-action--select ${selectMode === true ? 'card-details__combine-action--close' : ''}`}
            onClick={() => {
              playSound('main');
              setSelectMode(!selectMode)
              setSelectedItems([]);
            }}
          >
            {
              selectMode === false ?
                'Select Packs To Open'
                :
                'Cancel'
            }
          </button>
          { selectedItems.length >= 2 &&
            <button
            className={`card-details__combine-action card-details__button--craft ${isLoading ? 'loading' : ''}`}
            disabled={selectedItems.length < 2 || isLoading ? true : false}
            type="button"
            onClick={combineCards}
          >
            Open {combineText}
          </button>
          }
        </div>
        <p className="card-details__combine-hint">
          {combineHint}
        </p>
      </section>
      <ActiveItemDivider />
    </>
  )
}

export default CombinePacks;

